import AuthService from "../services/Auth";

import useAuthorizedQuery from "../common/hooks/useAuthorizedQuery";

export const makeQueryKey = () => "currentUser";

function useFetchCurrentUser() {
  const key = makeQueryKey();

  return useAuthorizedQuery(key, () => AuthService.fetchCurrentUser());
}

export default useFetchCurrentUser;
